export const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

export const openUrl = (url: string) => {
  window.open(url, "_blank");
};

export const formattedBillingAmount = (amount: number): string => {
  if (amount === undefined || amount === null) return "-";
  const dollars = amount / 100;
  return `$${dollars.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
